import React from 'react'
import { Outlet, useLocation } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import Sidebar from './Sidebar'
import Header from './Header'
import { setSidebarMobileOpen } from '../../store/slices/uiSlice'
import './Layout.css'

const Layout = () => {
  const dispatch = useDispatch()
  const location = useLocation()
  const { sidebarCollapsed, sidebarMobileOpen } = useSelector((state) => state.ui)

  React.useEffect(() => {
    dispatch(setSidebarMobileOpen(false))
  }, [location.pathname, location.search, dispatch])

  return (
    <div className={`layout ${sidebarMobileOpen ? 'sidebar-mobile-open' : ''}`}>
      <div
        className={`sidebar-overlay ${sidebarMobileOpen ? 'show' : ''}`}
        onClick={() => dispatch(setSidebarMobileOpen(false))}
        aria-hidden={!sidebarMobileOpen}
      />
      <Sidebar />

      <div className={`main-content ${sidebarCollapsed ? 'sidebar-collapsed' : ''}`}>
        <Header />

        <main className="content-area">
          <Outlet />
        </main>
      </div>
    </div>
  )
}

export default Layout
